import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import RadioGroup, { IProps } from "./RadioGroup";

type Story = ComponentStory<typeof RadioGroup>;

const OPTIONS = ["investigation", "block_on_request", "inventory_financing"] as const;

const commonArgs: IProps<(typeof OPTIONS)[number], string> = {
    options: OPTIONS,
    trackName: "radio_group",
    getOptionValue: v => v,
    getOptionLabel: v => {
        switch (v) {
            case "investigation":
                return "Investigation";
            case "block_on_request":
                return "Block on Request";
            case "inventory_financing":
                return "Inventory Financing";
            default:
                return null;
        }
    }
};

export default {
    title: "Form components/RadioGroup",
    component: RadioGroup,
    args: commonArgs
} as ComponentMeta<typeof RadioGroup>;

const Template: Story = args => <RadioGroup {...args} />;

export const Default = Template.bind({});

export const DefaultValue = Template.bind({});
DefaultValue.args = {
    defaultValue: OPTIONS[0]
};

export const Label = Template.bind({});
Label.args = {
    label: "Radio Group Title"
};
